<script>
import * as sdk from '../../functions/sdk';
import { store } from '../../functions/mixins';
import UiContainer from '../ui/Container';
import UiHeadline from '../ui/Headline';
import UiSubheader from '../ui/Subheader';
import UiLoading from '../ui/Loading';
import UiButton from '../ui/Button';
import UiInput from '../ui/Input';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiHeadline,
        UiSubheader,
        UiLoading,
        UiButton,
        UiInput,
    },
    data() {
        return {
           password: '',
           retype: '',
           loading: false,
           error: false,
        };
    },
    created() {
        if (this.isLogged) {
            this.$router.push({name: 'home'});
        }
    },
    methods: {
       setPassword() {
           const {
               password,
               retype,
           } = this;
           const token = this.$route.params.token;
           if (!password.length || password !== retype) {
               this.error = true;
           } else {
               this.loading = true;
               this.error = false;
               sdk.accessManagement.changePasswordWithToken(token, password).then(() => {
                   this.$router.push({name: 'home'});
               }).catch(() => {
                   this.error = true;
               }).finally(() => {
                   this.loading = false;
               });
           }
       },
    },
    watch: {
        isLogged(newValue) {
            if (newValue) {
                this.$router.push({name: 'home'});
            }
        },
    },
}
</script>

<template>
    <ui-container>
        <ui-headline>{{ $t('initialPassword.pageTitle') }}</ui-headline>
        <div :class="{InlineForm: true, Error: error, Loading: loading}">
            <ui-input v-model="password" @input="error = false" :label="$t('initialPassword.labelPassword')" type="password" />
            <ui-input v-model="retype" :label="$t('initialPassword.labelRetype')" type="password" />
            <div class="LoadingOverlay">
                <ui-loading />
            </div>
        </div>
        <div class="FlexRow JustifyEnd mt-3">
            <ui-button @click.native="setPassword()" :disabled="loading" class="semibig">
                {{ $t('initialPassword.setPassword') }}
            </ui-button>
        </div>
    </ui-container>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.InlineForm
    background #fff
    display flex
    align-items center
    border 1px solid $cBorder
    position relative
    overflow hidden
    .Input
        border-left none
        border-top none
        border-bottom none
        flex 1 1 auto
    .Button
        flex 0 0 auto
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Error
        border-color $cError
        .Input
            border-color $cError
    &.Loading
        .LoadingOverlay
            transform translate(0,0)

</style>

